import React, { useEffect } from "react";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { ReactComponent as Sedan } from "../../images/svg/vehicle_sedan.svg";
import { ReactComponent as Vans } from "../../images/svg/vehicle_van.svg";
import { ReactComponent as Hatchbacks } from "../../images/svg/vehicle_hatchback.svg";
import { ReactComponent as CrossoverSuv } from "../../images/svg/vehicle_crossover.svg";
import { ReactComponent as Convertible } from "../../images/svg/vehicle_convertible.svg";
import { ReactComponent as Coupe } from "../../images/svg/vehicle_coupe.svg";
import { ReactComponent as Greenvehicle } from "../../images/svg/vehicle_greenvehicle.svg";
import { ReactComponent as Pickuptruck } from "../../images/svg/vehicle_pickuptruck.svg";

import "./filter.scss";
import "./button.scss";
import { Fade, Slider, ThemeProvider } from "@mui/material";
import { useTranslation } from "react-i18next";

import comingSoonIMG from "../../images/coming_soon-min.png";
import { useDispatch, useSelector } from "react-redux";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {getDefaultVehicleSegments, getFilterSegment, getSegmentsByFilter, getSelectedYear, getVehiclesByYear, handlePriceRangeSlider, labelPriceRange, minimumPriceByFilter,
    setBaseGroup, setFilteredPrinceRange, setFilterGroup, setMax, setMaximumPriceRange, setMin, setMinimumPriceRange, setUpdatedPrice, setUpdatedPriceRange, setVehiclesPrinceRange, getFilterSegmentClicked
} from "../../slices/vehicleSlice";
import CloseIcon from "@mui/icons-material/Close";
import BasicModal from "../Modal/BasicModal";
import { createTheme } from "@mui/material/styles";
import { currencyConverter } from "../../utility/methods";
import {trackPriceRangeSliderMax, trackPriceRangeSliderMin, trackVehicleModelsCancelled, trackVehicleSegmentDeselected, trackVehicleSegmentSelected} from "../GoogleTagManager.utils";
import {useMediaQuery} from "react-responsive";
import { sendSegment} from "../vehicle/vehicle.utility";

const theme = createTheme({
    components: {
        MuiModal: {
            styleOverrides: {
                root: {
                    zIndex: "1",
                },
            },
        },
        MuiBackdrop: {
            styleOverrides: {
                root: {
                    backgroundColor: "transparent",
                },
            },
        },
    },
});

const FilterToggle = ({LOCALE,filteredVehiclesFromPriceRange, setDraggingSlider, draggingSlider, setVehicleType, isVehicleTypeSelected}) => {
    let [segmentArray, setSegment] = React.useState([]);
    const getYear = useSelector(getSelectedYear);
    const getVehicleYear = useSelector(getVehiclesByYear);
    const defaultSegments = useSelector(getDefaultVehicleSegments);
    let filteredSegment = useSelector(getFilterSegment);
    const maxTablet = useMediaQuery({query: '(max-width: 899px)'})
    const baseGroup = useSelector(setBaseGroup);
    const filterGroup = useSelector(setFilterGroup);
    const activeYear = useSelector(getSelectedYear);
    const { t } = useTranslation();
    const dispatch = useDispatch();
    let beforeChange = null;
    let [isActiveID, setActiveSegmentID] = React.useState([]);
    const [open, setOpen] = React.useState(false);
    const minimumPrice = useSelector(setMinimumPriceRange)
    const maximumPrice = useSelector(setMaximumPriceRange)
    let [thumb, isActiveThumb] = React.useState(false);
    const updatedPriceRange = useSelector(setUpdatedPrice);
    let min = useSelector(setMin)
    let max = useSelector(setMax)
    const vehicleSegmentTypeSelected = useSelector(getFilterSegmentClicked);

    const priceRangeChanged = useSelector(labelPriceRange);
    let [counter, setCounter] = React.useState(0);
    const [checked, setChecked] = React.useState(false);
    const maxMobileHeight = useMediaQuery({ query: '(max-height: 450px)' })
    const minMobileWidth = useMediaQuery({ query: '(min-width: 700px)' })
    const [clickedIds, setClickedIds] = React.useState([]);
    const [priceChanged, isMinMaxChanged]  = React.useState(false);

    let minPriceArr = [];
    let maxPriceArr = [];
    let minP, maxP;
    const handleOpen = () => {
        setOpen(true);
        setChecked(true);
        if (minMobileWidth && maxMobileHeight) {
            const appBar = document.querySelector(".appNavbar");
            appBar.style.zIndex = "1";
        }
        document.body.classList.add("modal-open");
    };

    const handleClose = () => {
        setOpen(false);
        setChecked(false);
        setSegment(null);
        document.body.classList.remove("modal-open");
    };

    useEffect(() => {
        thumb = false;
        setCounter(0)
        dispatch(setFilteredPrinceRange({ price: [], segmentSelected: [] }));
        showPriceValue();
        setOpen(false);
        setClickedIds([]);
        dispatch(getSegmentsByFilter({clearSegments: true}));

    }, [activeYear]);

    function valuetext(range) {
        return currencyConverter(`${range}`,LOCALE);
    }

    const handleChange = async (event, newValue) => {
        if (clickedIds.length === 0) {
            setVehicleType(false)
            setDraggingSlider(true)
        } else {
            !isVehicleTypeSelected && setDraggingSlider(true);
        }
        if (!beforeChange) {
            beforeChange = [...updatedPriceRange];
        }
        if (beforeChange[0] !== newValue[0] && beforeChange[1] !== newValue[1]) {
            return;
        }
        if (beforeChange[0] !== newValue[0]) {
            dispatch(minimumPriceByFilter({minimumPrice: newValue[0]}))
            isMinMaxChanged(true)
            trackPriceRangeSliderMin(baseGroup)
        } else if (beforeChange[1] !== newValue[1]) {
            isMinMaxChanged(true)
            dispatch(minimumPriceByFilter({maximumPrice: newValue[1]}))
            trackPriceRangeSliderMax(baseGroup)
        }
        dispatch(setUpdatedPriceRange(newValue));
        await changePrice(newValue);

        if (min && max !== "") {
            isActiveThumb(true);
            setCounter(1);
        }

        await dispatch(setVehiclesPrinceRange({ minimumPrice: newValue[0], maximumPrice: newValue[1] }));
        if (!(min === newValue[0] && max === newValue[1])) {
            await dispatch(setFilteredPrinceRange({ price: [newValue[0], newValue[1]], segmentSelected: [] }));
        } else {
            await dispatch(setFilteredPrinceRange({ price: [], segmentSelected: [] }));
        }
        if (draggingSlider) {
            await dispatch(setFilteredPrinceRange({ price: [newValue[0], newValue[1]], segmentSelected: filteredSegment ? filteredSegment : [] }));
        } else {
            await dispatch(setFilteredPrinceRange({ price: [newValue[0], newValue[1]], segmentSelected: filteredSegment }));
        }


        if (min === minimumPrice && max === maximumPrice) {
            isActiveThumb(false);
            setCounter(0);
            dispatch(setFilteredPrinceRange({initialPriceRange:[minimumPrice,maximumPrice], resetFilters: true}));

        }
        if (thumb === false && filteredSegment.length) {
            setCounter(filteredSegment.length);
        }

    };

    function changePrice(newPrice) {
        dispatch(handlePriceRangeSlider({min: newPrice[0], max: newPrice[1]}));
        if (minimumPrice === newPrice[0] && maximumPrice === newPrice[1]) {
            isActiveThumb(false);
            setDraggingSlider(false)
            isMinMaxChanged(false)
        }
    }

   async function showPriceValue () {
        await getVehicleYear
            .filter((year) => year.year === getYear)
            .map((vehicle) => {
                minPriceArr.push(vehicle.pricing[Object.keys(vehicle.pricing)[0]]);
                maxPriceArr.push(vehicle.pricing[Object.keys(vehicle.pricing)[1]]);
            });
        minP = Math.min(...minPriceArr);
        maxP = Math.max(...maxPriceArr);
        setDraggingSlider(false);
       dispatch(handlePriceRangeSlider({  min: minP, max: maxP, minimumPrice: minP, maximumPrice: maxP}));
       dispatch(setUpdatedPriceRange([minP, maxP]));

    }

    async function priceRange() {
        if (thumb === true) {
            min = updatedPriceRange[0];
            max = updatedPriceRange[1];
            handleOpen();
        } else {
            dispatch(handlePriceRangeSlider({min: "", max: "", minimumPrice: "", maximumPrice: ""}));
            handleOpen();
           getVehicleYear
                .filter((year) => year.year === getYear)
                .map((vehicle) => {
                    minPriceArr.push(vehicle.pricing[Object.keys(vehicle.pricing)[0]]);
                    maxPriceArr.push(vehicle.pricing[Object.keys(vehicle.pricing)[1]]);
                });
            minP = Math.min(...minPriceArr);
            maxP = Math.max(...maxPriceArr);

            dispatch(handlePriceRangeSlider({ minimumPrice: minP, maximumPrice:maxP, min: minP, max: maxP}));

            dispatch(setUpdatedPriceRange([minP, maxP]));
            counter = 1;
        }
        dispatch(minimumPriceByFilter({ minimumPrice: minP, maximumPrice: maxP }));
    }

    function onSegmentClick(event, id) {
        setVehicleType(true)
        if (clickedIds.includes(id)) {
            setClickedIds(prev => prev.filter(item => item !== id));
        } else {
            setClickedIds(prev => [...prev, id]);
        }
        if (!vehicleSegmentTypeSelected.includes(id)) {
            setActiveSegmentID([...vehicleSegmentTypeSelected, id]);
        } else {
            segmentArray = vehicleSegmentTypeSelected.filter((item) => item !== id);
            setActiveSegmentID([...segmentArray]);
        }
        dispatch(getSegmentsByFilter({segmentClicked: id}));
        trackVehicleSegmentSelected(baseGroup)
    }

    const handleSubmit = () => {
        !draggingSlider && vehicleSegmentTypeSelected.length && dispatch(getSegmentsByFilter(vehicleSegmentTypeSelected));
            if (!draggingSlider && vehicleSegmentTypeSelected.length < 1){
                setDraggingSlider(false)
                setVehicleType(false)
                dispatch(getSegmentsByFilter([]));
            } else if (vehicleSegmentTypeSelected.length === 0) {
                dispatch(getSegmentsByFilter([]));
            }
        sendSegment(min,max,isActiveID,isActiveThumb,filteredSegment,dispatch,handleClose,filterGroup,minimumPrice,maximumPrice,thumb,setCounter)
    }

    function getSegmentImages(id) {
        switch (id) {
            case "Crossovers&SUVs":
                return <CrossoverSuv />;
            case "Sedans":
                return <Sedan />;
            case "Vans":
                return <Vans />;
            case "Hatchbacks":
                return <Hatchbacks />;
            case "Convertibles":
                return <Convertible />;
            case "Coupes":
                return <Coupe />;
            case "Trucks":
                return <Pickuptruck />;
            case "Greenvehicle":
                return <Greenvehicle />;
            default:
                return comingSoonIMG;
        }
    }

    return (
        <React.Fragment>
            <div className={"appModal"} key={activeYear}>
                <div className={"filter-submit"} key={activeYear}>
                    <button
                        type={"button"}
                        className={"primary-btn"}
                        onClick={priceRange}
                    >
                        <FilterAltIcon className={"filter-icon"} fontSize={"small"} />
                        {t("navigation.filterModels")}
                        <div
                            className={
                                (draggingSlider && (filteredVehiclesFromPriceRange.length > 0 || vehicleSegmentTypeSelected.length > 0))
                                    ? (filteredVehiclesFromPriceRange.length > 0 || vehicleSegmentTypeSelected.length > 0)
                                        ? "filter-circle"
                                        : ""
                                    : vehicleSegmentTypeSelected.length ? "filter-circle" : ""
                            }
                            key={counter}
                        >
                            {((draggingSlider && (filteredVehiclesFromPriceRange.length > 0 || vehicleSegmentTypeSelected.length > 0)
                                        ? filteredVehiclesFromPriceRange.length
                                        : vehicleSegmentTypeSelected.length
                                ) || null)}
                        </div>
                    </button>
                </div>
                <ThemeProvider theme={theme}>
                    <BasicModal
                        open={open}
                        onClose={handleClose}
                        hideBackdrop={false}
                        disableScrollLock={true}
                        role={'dialog'}
                    >
                        <Fade
                            in={checked}
                            style={{ transformOrigin: "50% 50% 0" }}
                            {...(checked ? { timeout: 1000 } : {})}
                        >
                            <div className={"filter-container"}>
                                <div className={"filter-heading"}>
                                    {t("filterModels.heading")}
                                    <button
                                        type="button"
                                        className={"close"}
                                        onClick={handleClose}
                                    >
                                        <CloseIcon fontSize={"small"} />
                                    </button>
                                </div>
                                <div className={"filter-row"} id={"vehicle-type-filter"}>
                                    {defaultSegments.map((id) => (
                                        <React.Fragment>
                                            <div
                                                key={id}
                                                className={"filter-data"}
                                            >
                                                <div
                                                    id={id}
                                                    className={
                                                        (draggingSlider ? filteredVehiclesFromPriceRange : vehicleSegmentTypeSelected)?.includes(id)
                                                            ? "img-filter active-filter-checked"
                                                            : "img-filter"
                                                    }
                                                    onClick={(e) => !draggingSlider && onSegmentClick(e, id)}
                                                >

                                                    {
                                                        !draggingSlider && priceChanged ?
                                                            <div className="hover-container">
                                                                {!maxTablet && !(vehicleSegmentTypeSelected)?.includes(id) && (
                                                                    <div className="filter-tooltip">
                                                                        {t('filterModels.noVehiclesSelect')}
                                                                    </div>
                                                                )}
                                                            </div> :
                                                            <div className="hover-container">
                                                                {!maxTablet && !(draggingSlider ? filteredVehiclesFromPriceRange : vehicleSegmentTypeSelected)?.includes(id) && draggingSlider && (
                                                                    <div className="filter-tooltip">
                                                                        {t('filterModels.noVehiclesSelect')}
                                                                    </div>
                                                                )}
                                                            </div>
                                                    }
                                                    <CheckCircleIcon
                                                        fontSize={"small"}
                                                        className={"active-check"}
                                                    />
                                                    {getSegmentImages(id)}
                                                    <div className={"segment-heading"}>{t(id)}</div>
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    ))}
                                </div>
                                <div className={"filter-heading"}>
                                    {t("filterModels.priceRangeHeading")}
                                </div>
                                <div className={"filter-slider"}
                                     id={"vehicle-price-range"}
                                     data-testid="slider">
                                    <Slider
                                        value={updatedPriceRange}
                                        onChange={handleChange}
                                        getAriaValueText={valuetext}
                                        min={minimumPrice}
                                        max={maximumPrice}
                                        step={500}
                                    />
                                </div>
                                <div className={"price-values"}>
                                    <span> MIN: </span> {currencyConverter(priceRangeChanged.length ? priceRangeChanged[0] : min,LOCALE)}
                                    <span> | MAX: </span> {currencyConverter(priceRangeChanged.length ? priceRangeChanged[1] : max,LOCALE)}
                                </div>
                                <div className={"filter-footer"}>
                                    <div className="tooltip-wrapper" style={{ display: "inline-block", position: "relative" }}>
                                        <button
                                            className={`primary-btn ${draggingSlider ? (filteredVehiclesFromPriceRange.length === 0 ? "disabled-btn" : "") : 
                                                (priceChanged && vehicleSegmentTypeSelected.length === 0 ? "disabled-btn" : "")}`}
                                            onClick={handleSubmit}
                                            id={"vehicle-filter-update"}
                                            disabled={draggingSlider ? filteredVehiclesFromPriceRange.length === 0 : priceChanged && vehicleSegmentTypeSelected.length === 0}
                                            style={{
                                                pointerEvents: (draggingSlider ? filteredVehiclesFromPriceRange.length === 0 : priceChanged && vehicleSegmentTypeSelected.length === 0)
                                                    ? "none"
                                                    : "auto"
                                            }}
                                        >
                                            {t('overview.changeSelectModal.update')}
                                        </button>
                                        {(draggingSlider ? filteredVehiclesFromPriceRange.length === 0 :
                                            priceChanged && vehicleSegmentTypeSelected.length === 0) && (
                                            <span className="custom-tooltip">
                                                {t('filterModels.noVehiclesSelect')}
                                            </span>
                                        )}
                                    </div>
                                    <button
                                        className={"btn-default"}
                                        id={"vehicle-filter-cancel"}
                                        onClick={() => {
                                            trackVehicleModelsCancelled(filterGroup)
                                            handleClose()
                                        }}
                                    >
                                        {t('overview.changeSelectModal.cancel')}
                                    </button>
                                </div>
                            </div>
                        </Fade>
                    </BasicModal>
                </ThemeProvider>
            </div>
        </React.Fragment>
    );
};
export default FilterToggle;
